export default {
  promotion: 'PromotionTriggerHistory',
  order: 'Order'
}
